import { Button } from "@progress/kendo-react-buttons";
import { getDateWithoutTime, getFormattedCurrentTime } from "../../../commons/helpers/Dates";
import { useAppSelector } from "../../../redux/store";

interface CustomCommandCellProps {
    dataItem: any;
    editField: string;
    update: (dataItem: any) => void;
    cancel: (dataItem: any) => void;
    edit: (dataItem: any) => void;
    deleteVehicule: (dataItem: any) => void;
    itemInEdit: boolean;
    date: Date;
}

export default function CustomCommandCell(props: CustomCommandCellProps) {
    const today = getDateWithoutTime(new Date());
    const { dataItem } = props;
    const inEdit = dataItem[props.editField];
    const d_liv69 = useAppSelector(state => state.appState.d_liv69);

    return inEdit ? (
        <td className="k-command-cell">
            <Button className="blueButton" icon="save" onClick={() => props.update(dataItem)} title="Enregistrer" />
            <Button className="blueButton" icon="cancel" onClick={async () => props.cancel(dataItem)} title="Annuler" />
        </td>
    ) : (
        <td className="k-command-cell">
            <Button className="blueButton" icon="edit" onClick={() => props.edit(dataItem)} title="Mettre à jour l'équipe" disabled={(props.itemInEdit || (props.date.getTime() < today.getTime()) || (props.date.getTime() === today.getTime() && props.dataItem.hreDepart < getFormattedCurrentTime())) || !d_liv69.canModify} />
            <Button className="blueButton" icon="delete" onClick={() => props.deleteVehicule(dataItem)} title="Supprimer le véhicule" disabled={(dataItem.route !== "" || props.itemInEdit) || !d_liv69.canDelete} />
        </td>
    );
}